import { inject, Injectable } from '@angular/core';
import { ProductListV2ConfigService } from '../product-list-v2-config/product-list-v2-config.service';
import { first, map, Observable, switchMap } from 'rxjs';
import { Product } from '../../models';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';
import { Assortment } from '../assortment.service';
import { CustomerStatisticsService } from '../customer-statistics/customer-statistics.service';

@Injectable({
  providedIn: 'root'
})
export class PreviouslyPurchasedProductListConfigService extends ProductListV2ConfigService {
  protected selectedCustomerService = inject(SelectedCustomerService);
  protected customerStatisticsService = inject(CustomerStatisticsService);

  protected fetchProducts(assortment: Assortment): Observable<Product[]> {
    return this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      switchMap(selectedCustomer => this.customerStatisticsService.getStatisticsByCustomer(selectedCustomer.id).pipe(first())),
      switchMap(data => this.productService.getProductsByIds(data.map(p => p.productId)).pipe(
        map(products => {
          return this.productSortService.sortProducts(products);
        })
      ))
    );
  }
}
